import { PlanRecallModal } from "../../targetList/contacts/recall/planRecallModal"
import { EventType } from "../dto"
import { EventProps } from "./dto"

export function EventsModal(props: EventProps) {
    const eventComponentMap: Record<EventType, React.FC<any>> = {
        [EventType.CALL]: PlanRecallModal,
        [EventType.MEETING]: PlanRecallModal,
    };

    const Component = eventComponentMap[props.eventType];
    return <Component {...props} />;
}